import Vue from 'vue';
import { mapGetters } from 'vuex';
import _ from 'lodash';
import { modals } from '@/mixins/modal';
import { guid } from '@/mixins/guid';
import tooltip from '@/mixins/components/tooltip';
import dropsLoader from '@/mixins/components/drops-loader';
import globalTabs from '@/mixins/components/tabs';
import StormAccountOptions from '@storm/admin/account-options';
import StormAccountRaw from '@storm/admin/account-raw';
import ProfilePic from './pic-modal';
import LeaveSite from './leave-site';
import DisableEnable from './disable-enable';
import HardDelete from './hard-delete';

export default Vue.component('profile-settings', {
  template: require('./template.html'),
  name: 'profile-settings',
  mixins: [modals, guid],
  components: {
    ProfilePic,
    LeaveSite,
    DisableEnable,
    HardDelete,
    dropsLoader,
    tooltip,
    globalTabs,
    StormAccountOptions,
    StormAccountRaw,
  },
  computed: {
    ...mapGetters([
      'currentUser',
      'userAttributes',
      'account',
      'stormUser',
    ]),
    opposite() {
      const isDisabled = this.currentUser.status === 'disabled';
      return isDisabled ? 'Enable' : 'Disable';
    },
  },
  data() {
    return {
      activeSite: null,
      cols: ['alias'],
      filterKey: '',
      paginate: ['sitelist'],
      showPencil: false,
      fullname: '',
      email: '',
      typeConfirm: '',
      confirmPassed: false,
      loaders: {
        fullName: false,
      },
      editFullName: false,
      editAccount: false,
      modals: {
        profilePic: false,
        deleteSelf: false,
        leaveSite: false,
        disableEnable: false,
        hardDelete: false,
      },
      tabs: [
        {
          title: 'Account Options',
          render: StormAccountOptions,
        },
        {
          title: 'Raw Account Data',
          render: StormAccountRaw,
        },
      ],
    };
  },
  watch: {
    'modals.deleteSelf': function o(o) {
      if (o) {
        this.resetModal();
      }
    },
  },
  created() {
    this.getUserAttributes();
  },
  mounted() {
    // used for the modal mixin
    this.cls = '.adminUi-modalOverlay';
  },
  methods: {
    async getUserAttributes() {
      const name = this.currentUser.fullName;
      const email = this.currentUser.email;
      this.fullname = _.clone(name);
      this.email = _.clone(email);
    },
    toggleModal(type, c) {
      this.modals[type] = !this.modals[type];
      const content = !c ? this.$refs[type] : this.$refs[type].$el;
      if (this.modals[type]) {
        this.modelMoveOut(content);
      } else {
        this.modalMoveIn(content);
      }
    },
    confirm() {
      if (this.currentUser.userName === this.typeConfirm) {
        this.confirmPassed = true;
      } else {
        this.confirmPassed = false;
      }
    },
    resetModal() {
      this.confirmPassed = false;
      this.typeConfirm = '';
    },
    saveAttributes() {
      this.$validator.validate('fullname', this.fullname).then(async (result) => {
        if (result) {
          this.loaders.fullName = true;
          const attrs = [];
          const name = {
            Name: 'name',
            Value: this.fullname,
          };
          attrs.push(name);
          const notif = {
            id: this.guid(),
            type: 'success',
            message: 'User information updated!',
          };
          try {
            // if subuser, update owners data
            if (this.currentUser.subuser) {
              await this._SEND([{
                name: 'updateSubUserAttrs',
                payload: {
                  attr: 'fullname',
                  value: this.fullname,
                },
              }]);
            }
            await this._cognitoUpdateAttrs({ attrs });
            this.$store.dispatch('setUserAttribute', {
              fullName: this.fullname,
            });
            this.editFullName = false;
          } catch (e) {
            notif.type = 'error';
            notif.message = `${e.message || e}. This has been reported.`;
            await this._reportError({
              error: e,
              fn: 'saveAttributes',
            });
          } finally {
            this.loaders.fullName = false;
            this.$store.dispatch('addNotification', notif);
          }
        }
      });
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/admin/account/profile/index.js